import { getUserInitials } from "../utils/Utility";
import infoImage from "../icons/infoblue.svg";

export const RenderIf = ({ children, isTrue }) => {
  return isTrue ? children : null;
};

export function getInitials(userName) {
  if (userName) {
    let names = userName.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }
}

export function getFirstAlphabet(userName) {
  if (userName) {
    let names = userName.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();
    return initials;
  }
}


export function getCurrentDateTime(separator = "/") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let hours = newDate.getHours();
  let minutes = newDate.getMinutes();
  let seconds = newDate.getSeconds();
  date = date < 10 ? "0" + date : date;
  month = month < 10 ? "0" + month : month;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  //seconds = seconds < 10 ? "0" + seconds : seconds;

  return `${year}${separator}${month}${separator}${date} ${hours}:${minutes}`;
}

export function getCurrentDatewithTime(separator = "/") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let hours = newDate.getHours();
  let minutes = newDate.getMinutes();
  let seconds = newDate.getSeconds();
  date = date < 10 ? "0" + date : date;
  month = month < 10 ? "0" + month : month;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  return `${date}${separator}${month}${separator}${year} ${hours}:${minutes}`;
}

export function getTodaysDate() {
  let todayDate = new Date();
  todayDate = todayDate.toISOString().substring(0, 10);
  return todayDate;
}

export function formatDate(input) {
  const [datePart] = input.split(" ");
  const [year, month, day] = datePart.split("/");
  return `${day}/${month}/${year}`;
}

export function formatDateInDDMMYYYY(dateStr) {
  if (dateStr !== undefined && dateStr !== "") {
    let str = dateStr.toString().trim();
    let time = "";
    if (str.indexOf(" ") !== -1) {
      time = str.split(" ").slice(1).join(" ");
      str = str.split(" ")[0];
      if (time && time.split(":").length === 3) {
        time = time.substring(0, 5);
      }
    }

    let day, month, year;

    if (str.includes("-")) {
      let parts = str.split("-");
      if (parts[0].length === 4) {
        // yyyy-mm-dd
        [year, month, day] = parts;
      } else {
        // dd-mm-yyyy
        [day, month, year] = parts;
      }
    } else if (str.includes("/")) {
      let parts = str.split("/");
      if (parts[0].length === 4) {
        // yyyy/mm/dd
        [year, month, day] = parts;
      } else if (parts[2] && parts[2].length === 4 && parseInt(parts[0]) <= 12 && parseInt(parts[1]) > 12) {
        // M/D/YYYY (US format - month first, day > 12)
        [month, day, year] = parts;
      } else if (parts[2] && parts[2].length === 4 && parseInt(parts[1]) <= 12 && parseInt(parts[0]) > 12) {
        // D/M/YYYY (day first, day > 12)
        [day, month, year] = parts;
      } else if (parts[2] && parts[2].length === 4) {
        // Ambiguous - treat as M/D/YYYY (US format)
        [month, day, year] = parts;
      } else {
        // dd/mm/yyyy fallback
        [day, month, year] = parts;
      }
    } else {
      // Try parsing as Date object (ISO, etc.)
      let dateObj = new Date(str);
      if (!isNaN(dateObj.getTime())) {
        day = String(dateObj.getDate()).padStart(2, "0");
        month = String(dateObj.getMonth() + 1).padStart(2, "0");
        year = dateObj.getFullYear();
      } else {
        return dateStr;
      }
    }

    day = String(day).padStart(2, "0");
    month = String(month).padStart(2, "0");

    let result = `${day}/${month}/${year}`;
    return time ? `${result} ${time}` : result;
  } else {
    return "";
  }
}

export function formatDateTimeInDDMMYYYY(dateStr) {
  if (dateStr !== undefined && dateStr !== "") {
    let str = "";
    let time = "";

    if (dateStr.indexOf(" ") !== -1) {
      [str, time] = dateStr.split(" ");
      if (time && time.split(":").length === 3) {
        time = time.substring(0, 5);
      }
    } else {
      str = dateStr;
    }

    if (str !== "") {
      let parts = str.split(/[-\/]/);
      let day, month, year;

      if (parts[0].length === 4) {
        [year, month, day] = parts;
      } else {
        [day, month, year] = parts;
      }

      return time ? `${day}-${month}-${year} ${time}` : `${day}-${month}-${year}`;
    }
    return "";
  }
  return "";
}

const contains = (target, lookingFor) => {
  return target && target.indexOf(lookingFor) >= 0;
};

export function myTextMatchFunc(value, filterText, aliases) {
  let filterTextLowerCase = filterText ? filterText.toLowerCase() : "";
  let valueLowerCase = value.toString().toLowerCase();
  let literalMatch = contains(valueLowerCase, filterTextLowerCase);
  return (
    !!literalMatch || !!contains(valueLowerCase, aliases[filterTextLowerCase])
  );
}

export const resetAllFilter = (gridRef) => {
  gridRef.current.api.setFilterModel(null);
};

export function resetFilter(gridRef, item, feildName) {
  let item1 = item.substring(0, item.indexOf(":") - 1);
  let col = gridRef.current.api.getFilterModel();
  for (const key of Object.keys(col)) {
    if (key === feildName(item1)) {
      delete col[key];
    }
  }
  gridRef.current.api.setFilterModel(col);
}

const customComparator = (valueA, valueB) => {
  return valueA?.toLowerCase().localeCompare(valueB?.toLowerCase());
};

export function defaultColParas() {
  return {
    flex: 1,
    sortable: true,
    resizable: true,
    textAlign: "center",
    suppressMovable: true,
    suppressRowTransform: true,
    //width: 100,
    // minWidth: 150,
    // maxWidth: 180,
    enableCellChangeFlash: true,
    filterParams: {
      buttons: ["reset", "apply"],
      closeOnApply: true,
      defaultJoinOperator: "OR",
    },
    filter: "agTextColumnFilter",
    comparator: customComparator
  };
}

function pad2(n) {
  return (n < 10 ? "0" : "") + n;
}

export function formatDateDD_MM_YYYY(input) {
  if (input !== "") {
    let input1 = new Date(input);
    const newDate = `${pad2(input1.getDate())}-${pad2(
      input1.getMonth() + 1
    )}-${pad2(input1.getFullYear())}`;
    //console.log("dates", input, newDate);

    return newDate;
  }
  else {
    return "";
  }
}

export function formatDateInYYYYMMDD(dtStr, dateSeperator = "/") {
  if (dtStr !== "") {
    let str = dtStr.toString().trim();
    let separator = "-";
    if (str.indexOf(" ") !== -1) {
      str = str.split(" ")[0];
    }

    let day, month, year;

    if (str.includes("-")) {
      let parts = str.split("-");
      if (parts[0].length === 4) {
        [year, month, day] = parts;
      } else {
        [day, month, year] = parts;
      }
    } else if (str.includes("/")) {
      let parts = str.split("/");
      if (parts[0].length === 4) {
        [year, month, day] = parts;
      } else if (parts[2] && parts[2].length === 4 && parseInt(parts[0]) <= 12 && parseInt(parts[1]) > 12) {
        [month, day, year] = parts;
      } else if (parts[2] && parts[2].length === 4 && parseInt(parts[1]) <= 12 && parseInt(parts[0]) > 12) {
        [day, month, year] = parts;
      } else if (parts[2] && parts[2].length === 4) {
        [month, day, year] = parts;
      } else {
        [day, month, year] = parts;
      }
    } else {
      let dateObj = new Date(str);
      if (!isNaN(dateObj.getTime())) {
        day = String(dateObj.getDate()).padStart(2, "0");
        month = String(dateObj.getMonth() + 1).padStart(2, "0");
        year = dateObj.getFullYear();
      } else {
        return dtStr;
      }
    }

    return `${year}${separator}${String(month).padStart(2, "0")}${separator}${String(day).padStart(2, "0")}`;
  } else {
    return "";
  }
}

export const FilterChange = (param, setFilteredCol, headerName, setRowData, setExcelData) => {
  setFilteredCol([]);
  setRowData([]);
  let col = param.api.getFilterModel();

  if (param.api.getDisplayedRowCount() === 0) {
    param.api.showNoRowsOverlay();
  } else {
    param.api.hideOverlay();
  }
  if (Object.keys(col).length === 0) {
    //   a.classList.add("d-none");
  } else {
    // a.classList.remove("d-none");
    for (const key of Object.keys(col)) {
      let filter;
      if (col[key].filterType === "date") {
        if (col[key].condition1) {
          let fromDate1 = col[key].condition1.dateFrom
            ? formatDateDD_MM_YYYY(col[key].condition1.dateFrom)
            : col[key].condition1.dateFrom;
          let toDate1 = col[key].condition1.dateTo
            ? formatDateDD_MM_YYYY(col[key].condition1.dateTo)
            : col[key].condition1.dateTo;
          let fromDate2 = col[key].condition2.dateFrom
            ? formatDateDD_MM_YYYY(col[key].condition2.dateFrom)
            : col[key].condition2.dateFrom;
          let toDate2 = col[key].condition2.dateTo
            ? formatDateDD_MM_YYYY(col[key].condition2.dateTo)
            : col[key].condition2.dateTo;
          filter =
            headerName(key) +
            " : " +
            fromDate1 +
            (toDate1 ? " To " + toDate1 : "") +
            ", " +
            fromDate2 +
            (toDate2 ? " To " + toDate2 : "");
          console.log("true date");
        } else {
          filter =
            headerName(key) +
            " : " +
            col[key].dateFrom?.substring(0, 10) +
            (col[key].dateTo ? " To " + col[key].dateTo?.substring(0, 10) : "");
          console.log("false date", col[key].dateFrom?.substring(0, 10));
        }
      } else if (col[key].filterType === "number") {
        if (col[key].condition1) {
          filter =
            headerName(key) +
            " : " +
            col[key].condition1.filter +
            (col[key].condition1.filterTo
              ? " To " + col[key].condition1.filterTo
              : "") +
            ", " +
            col[key].condition2.filter +
            (col[key].condition2.filterTo
              ? " To " + col[key].condition2.filterTo
              : "");
        } else {
          filter =
            headerName(key) +
            " : " +
            col[key].filter +
            (col[key].filterTo ? " To " + col[key].filterTo : "");
        }
      } else {
        if (col[key].condition1) {
          filter =
            headerName(key) +
            " : " +
            col[key].condition1.filter +
            ", " +
            col[key].condition2.filter;
        } else {
          filter = headerName(key) + " : " + col[key].filter;
        }
      }

      let temp = [];
      param.api.forEachNodeAfterFilter(node => {
        temp.push(node.data);
      });

      setRowData(temp);
      setExcelData(temp);
      setFilteredCol((prev) => {
        return [...prev, filter];
      });
    }

  }
};

export function formatDateYYYY_MM_DD(input) {
  let input1 = new Date(input);
  const newDate = `${pad2(input1.getFullYear())}-${pad2(
    input1.getMonth() + 1
  )}-${pad2(input1.getDate())}`;
  //console.log("dates", input, newDate);
  return newDate;
}

export function getData(param) {
  // let col = param.api.getRenderedNodes();
  let filteredData = [];
  let col = param.forEachNodeAfterFilter(node => filteredData.push(node.data));

  // console.log("col", col.length); 
  // let filteredData = [];
  // for( let dt of col ) {
  //   filteredData.push(dt.data)
  // }
  //console.log("filteredData gbcs func",filteredData)
  return filteredData;
}

export function defaultEditableCol() {
  return {
    flex: 1,
    resizable: true,
    textAlign: "center",
    //sortable: true,
    // editable: true
  };
}

export function getTimeAMPMFormat(date) {
  if (date !== undefined && date !== "") {
    let hours = new Date(date).getHours();
    let minutes = new Date(date).getMinutes();
    // Check whether AM or PM
    let newformat = hours >= 12 ? 'pm' : 'am';
    // Find current hour in AM-PM Format
    hours = hours % 12;
    // To display "0" as "12"
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return (hours + ':' + minutes + newformat);
  }
  else {
    return "";
  }
}

export function UserNameInitials(params) {
  if (params.value != undefined && params.value != "") {
    let initials = getUserInitials(params.value);
    return (
      <div className="user-name-initials">
        <div className={"user-initials user-initials-color"}>
          <span>{initials}</span>
        </div>
      </div>)
  }
};

export function DashboardProjDataContainer(params) {
  let currentDate = formatDateInDDMMYYYY(getTodaysDate());
  return (
    <div className="dashboard-projects commonBorder">
      <span className="modalTitle" >
        {params.TabString} {params.SelectedProject.CustomerName}, {params.SelectedProject.Location} - {params.SelectedProject.ProjectName}
        &nbsp;
        <img
          src={infoImage}
          id="info"
          alt="info"
          onClick={params.handleInfoClick}
        />
      </span>
      <br />
      <span className="service-equip-labeltext">
        Project Completion Date - {formatDateInDDMMYYYY(params.SelectedProject.ProjEndDate)}
        |
        Today's Date - {currentDate}
      </span>
    </div>
  );
};
// Add these functions to existing common-functions.js

export const getFinancialYearStart = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  // Financial year starts from April (month 3 in 0-indexed)
  if (currentMonth >= 3) {
    return `${currentYear}-04-01`;
  } else {
    return `${currentYear - 1}-04-01`;
  }
};

export const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

// Convert date formats to dd/mm/yyyy hh:mm format
export function convertToStandardDateTime(dateTimeStr) {
  if (!dateTimeStr) return "";

  try {
    let date;

    // Check if format is dd/mm/yyyy hh:mm AM/PM
    if (dateTimeStr.includes('/') && (dateTimeStr.includes('am' || 'AM') || dateTimeStr.includes('pm' || 'PM'))) {
      const [datePart, timePart, ampm] = dateTimeStr.split(' ');
      const [day, month, year] = datePart.split('/');
      const [hours, minutes] = timePart.split(':');

      let hour24 = parseInt(hours);
      if (ampm === 'PM' && hour24 !== 12) hour24 += 12;
      if (ampm === 'AM' && hour24 === 12) hour24 = 0;

      return `${day}/${month}/${year} ${String(hour24).padStart(2, '0')}:${minutes}`;
    }

    // Check if format is yyyy/mm/dd hh:mm
    if (dateTimeStr.includes('/') && dateTimeStr.split('/')[0].length === 4) {
      const [datePart, timePart] = dateTimeStr.split(' ');
      const [year, month, day] = datePart.split('/');
      return `${day}/${month}/${year} ${timePart || ''}`;
    }

    // Try parsing as ISO date or other formats
    date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return dateTimeStr;

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (error) {
    console.error('Error converting date format:', error);
    return dateTimeStr;
  }
}